import { render, staticRenderFns } from "./CorporateClientBlock.vue?vue&type=template&id=74840f18&scoped=true"
import script from "./CorporateClientBlock.vue?vue&type=script&lang=js"
export * from "./CorporateClientBlock.vue?vue&type=script&lang=js"
import style0 from "./CorporateClientBlock.vue?vue&type=style&index=0&id=74840f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74840f18",
  null
  
)

export default component.exports